var CommonHelpers = (function() {
	'use strict';

	/**
	 * Проверка загрузки изображений
	 * @param objImages {object}
	 * @returns {promise}
	 */
	function checkImgLoading(objImages) {
		var deferred = $.Deferred();

		$.each(objImages, function(i, el) {
			$('<img />').attr('src', el.src).on('load', function() {
				$(this).remove();

				objImages[i].loaded = true;
			});
		});

		var int = setInterval(function() {
      var loaded = true;

			$.each(objImages, function(i, el) {
				if(!el.loaded)
					loaded = false;
			});

			if(loaded) {
				clearInterval(int);

				// Все изображения загрузились, резолвим
				deferred.resolve();
			}
		}, 250);

		return deferred.promise();
	}

  /**
	 * Вальдемар, поменяй этаж и отрисуй заново карту, будь другом, а?
   * @param items {object}
   * @param arr {array}
   */
  function valdemar(items, arr) {
    var $map = $('.box_blockMap').find('.map');

    $.each(items.buildings, function(i, el) {
      changeFloor(arr.floor);

      if(el.id == arr.id) {
        app.dom.$page.addClass('focus');

        $map.find('svg').remove();

        magicMap(items, el.id);
      }
    });
  }

  /**
	 * Поиск по элементам карты
   * @param items {object}
   * @param arr {array}
   */
	function searchMap(items, arr) {
    var dataKey = 'dataMap-' + arr.floor;

    items = items || JSON.parse(localStorage.getItem(dataKey));

    // Если не были переданы данные или данные не были получены локально, то делаем запрос на сервер
		if (!items) {
			requestDataMap(arr.floor)
				.then(function(items) {
          valdemar(items, arr);
        });
    }
    else {
      valdemar(items, arr);
    }
	}

  /**
	 * Запрос и кэширование данных с сервера для карты
   * @param floor {object}
   * @returns {promise}
   */
	function requestDataMap(floor) {
    var deferred = $.Deferred(),
				url= '',
				dataKey = 'dataMap-' + floor;

		if (CommonHelpers.isDev('gold-babylon-static.denode.ru'))
			url = 'static/components-assets/blockMap/' + dataKey + '.json';

    if(typeof cacheId !== 'undefined') {

      var localId = localStorage.getItem('cacheId');

      // ид кэша от бэка не совпадает с локальним ид кэша - полностью чистим локалстораже и добавляем в него новый ид
      if(localId !== cacheId) {
      	localStorage.clear();
        localStorage.setItem('cacheId', cacheId);
      }

      var storeMap = JSON.parse(localStorage.getItem(dataKey));

      // Данных еще нет в локальном кэше
      if(!storeMap) {

        $.ajax({
          type: 'GET',
          dataType: 'json',
          data: {
            action: 'getMap-' + floor
          },
          url: url
        })
          .done(function(items) {
            var data = items.data[0];

						localStorage.setItem(dataKey, JSON.stringify(data));

						magicMap(data);

            // резолвим промис с полученными данными
            deferred.resolve(data);
          })
          .fail(function() {
            console.log('ajax error');
          })
          .always(function() {
            //$spinner.hide();
          });
      }
      // данные есть в кэше
      else {
        magicMap(storeMap);
      }
    }

    return deferred.promise();
  }

	/**
	 * Получить данные для карты
	 * @param id {string|number}
	 */
	function getDataMap(id) {
		id = id || 0;

		// todo потестить на проде, а потом удалить

		//var dataKey = 'dataMap-' + id;
			//storeMap = JSON.parse(sessionStorage.getItem(dataKey));

    requestDataMap(id);

		// Если данные получены локально
		//if(storeMap) {
		//	magicMap(storeMap);
		//}
		//else {
		//	requestDataMap(id)
		//		.then(function(data) {
     //     magicMap(data);
     //   });
		//}
	}

	/**
	 * Проверка локального окружения на основе адресной строки
	 * @param staticUrl {string}
	 * @return {boolean}
	 */
	function isDev(staticUrl) {
		var hostName = window.location.hostname;

		return (hostName === 'localhost') || (hostName === staticUrl);
	}

	/**
	 * Преобразовать число с запятой в число с точкой
	 * @param num {Number}
	 * @returns {Number}
	 */
	function commaToDot(num) {
		num = num || 0;

		return parseFloat(num.replace(',', '.'));
	}

	/**
	 * Вешать на keydown, передавать контекст
	 * @param e
	 */
	function onlyNumbers(e) {
		var self = $(this);

		if((e.which < 48 || e.which > 57))
			e.preventDefault();

		self.val(self.val().replace(/[^\d].+/, ""));
	}

	/**
	 * Задержка исполнения функции
	 * @see https://github.com/component/debounce
	 * @param func {function}
	 * @param wait {number}
	 * @param [immediate] {bool}
	 * @returns {debounced}
	 */
	function debounce(func, wait, immediate) {
		var timeout, args, context, timestamp, result;
		if(null == wait) wait = 100;

		function later() {
			var last = Date.now() - timestamp;

			if(last < wait && last >= 0) {
				timeout = setTimeout(later, wait - last);
			}
			else {
				timeout = null;
				if(!immediate) {
					result  = func.apply(context, args);
					context = args = null;
				}
			}
		};

		var debounced = function() {
			context     = this;
			args        = arguments;
			timestamp   = Date.now();
			var callNow = immediate && !timeout;
			if(!timeout) timeout = setTimeout(later, wait);
			if(callNow) {
				result  = func.apply(context, args);
				context = args = null;
			}

			return result;
		};

		debounced.clear = function() {
			if(timeout) {
				clearTimeout(timeout);
				timeout = null;
			}
		};

		debounced.flush = function() {
			if(timeout) {
				result  = func.apply(context, args);
				context = args = null;

				clearTimeout(timeout);
				timeout = null;
			}
		};

		return debounced;
	}


	return {
		isDev: isDev,
		commaToDot: commaToDot,
		debounce: debounce,
		getDataMap: getDataMap,
		checkImgLoading: checkImgLoading,
		searchMap: searchMap
	}
})();